module.exports = __webpack_public_path__ + "static/media/hero3.8b10b5ee.jpg";